<modal-header-container [vs]="vs">
  <leplace-toolbar [noBackButton]="true" rightButton="close" [rightIcon]="true" [title]="title"
    (rightClick)="dismiss(null)" [rounded]="vs.fullScreen"></leplace-toolbar>
</modal-header-container>

<modal-container [vs]="vs"
  [ngClass]="!vs.fullScreen? (!vs.large?'modal-small-height':'modal-large-height'):'full-height'">

  <div class="padding-s">
    <div [ngClass]="direct ? '' : 'scroll-type-frame-list'">
      <dynamic-list *ngIf="loaded" [type]="componentType" [data]="listItems" [customSelect]="customSelect"
        emptyMessage="No items" [update]="update" (action)="selectItem($event)">
      </dynamic-list>
    </div>
  </div>

  <div fxFlex>
  </div>

  <div class="stick-bottom" *ngIf="!direct">
    <ion-row class="stick-bottom">
      <ion-col size="12">
        <ion-button class="action-button-fill button-color-alternate" (click)="submitSelection()"
          [disabled]="!selectedItem">
          <span class="button-font-size-s">Select</span>
          <icon-wrapper slot="start" [icon]="appIcons.check" [custom]="true"></icon-wrapper>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>

</modal-container>